import { styled } from '../../../../../modules';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

export const Card = styled.div<{ $color: string }>`
    width: 270px;
    aspect-ratio: 1.586;
    border-radius: 16px;
    background: linear-gradient(
        145deg,
        ${({ $color }) => $color} 0%,
        ${({ $color }) => $color}dd 50%,
        ${({ $color }) => $color}bb 100%
    );
    padding: 22px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
    color: #ffffff;
    position: relative;
    overflow: hidden;
    z-index: 1;
`;

export const BackgroundArt = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    user-select: none;
`;

export const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    z-index: 2;
`;

export const Label = styled.span`
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    opacity: 0.95;
`;

export const VisaImage = styled.img`
    width: 52px;
    height: auto;
    z-index: 2;
`;

export const NumberRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    z-index: 2;
`;

export const MaskedGroup = styled.span`
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 2px;
    opacity: 0.7;
`;

export const LastDigits = styled.span`
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 2px;
`;

export const HolderName = styled.span`
    font-size: 13px;
    font-weight: 500;
    opacity: 0.9;
    z-index: 2;
`;

export const LimitBadge = styled.div<{ $color: string; $borderColor: string }>`
    background-color: ${({ $color }) => $color}40;
    border: 1.5px solid ${({ $borderColor }) => $borderColor}40;
    border-radius: 12px;
    padding: 12px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    position: absolute;
    bottom: -32px;
    right: 0px;
    z-index: 2;
    backdrop-filter: blur(4px);
`;

export const LimitValue = styled.span<{ $color: string }>`
    font-size: 22px;
    font-weight: 800;
    background: linear-gradient(to right, ${({ $color }) => $color}, #ffffff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
`;

export const LimitLabel = styled.span<{ $color: string }>`
    font-size: 11px;
    color: ${({ $color }) => `${$color}90`};
    font-weight: 400;
`;
